<template>
  <v-container id="paymentmades" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/paymentdone/create'">
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title>{{ $i18n.t("Add New") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('Start Date')"
                class="purple-input"
                v-model="filter.startDate"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('End Date')"
                class="purple-input"
                v-model="filter.endDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-vendor-select withSelf clearable v-model="filter.vendor_id" />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Sequence No.')"
                v-model="filter.seqNo"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Reference No.')"
                v-model="filter.refNo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Trip No.')"
                v-model="filter.tripNo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('GRN No.')"
                v-model="filter.grnNo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn
                color="orange"
                class="mr-0"
                fab
                small
                dark
                @click="downloadAll()"
                :loading="loading"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-card-text-outline"
      :title="$i18n.t('Payments Done')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th>
                {{ $i18n.t("Seq No.") }}
              </th>
              <th>
                {{ $i18n.t("Ref No.") }}
              </th>
              <th>
                {{ $i18n.t("Entity") }}
              </th>
              <th>
                {{ $i18n.t("Date") }}
              </th>
              <th>
                {{ $i18n.t("Created At") }}
              </th>
              <th>
                {{ $i18n.t("Payment #") }}
              </th>
              <th>
                {{ $i18n.t("Vendor Name") }}
              </th>
              <th>
                {{ $i18n.t("Mode") }}
              </th>
              <th>
                {{ $i18n.t("Status") }}
              </th>
              <th class="text-right">
                {{ $i18n.t("Amount") }}
              </th>
              <th class="text-right">
                {{ $i18n.t("Unused Amount") }}
              </th>
              <th class="text-right">
                {{ $i18n.t("Paid") }}
              </th>
              <th class="text-right">
                {{ $i18n.t("TDS") }}
              </th>
              <th class="text-right">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <payment-done-row
            v-for="item in grid.rows"
            :key="item._id"
            :value="item"
            @reload="reload"
            :refresh="refresh"
          />
        </template>
      </v-simple-table>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import PaymentDoneRow from "@/views/paymentdone/PaymentDoneRow.vue";

@Component({
  name: "PaymentDones",
  components: { PaymentDoneRow },
})
export default class PaymentDones extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/paymentmade/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;

  filter = {
    startDate: null,
    endDate: null,
    seqNo: null,
    refNo: null,
    vendor_id: null,
    tripNo: null,
    grnNo: null,
    status: null,
  };

  get loading() {
    return common.loading;
  }

  async mounted() {
    this.showPage(1);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {
      startDate: null,
      endDate: null,
      seqNo: null,
      refNo: null,
      vendor_id: null,
    };

    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search() {
    this.filterUrl = "";
    if (this.filter.startDate)
      this.filterUrl += "&startDate=" + this.filter.startDate;
    if (this.filter.endDate)
      this.filterUrl += "&endDate=" + this.filter.endDate;
    if (this.filter.seqNo) this.filterUrl += "&seqNo=" + this.filter.seqNo;
    if (this.filter.refNo) this.filterUrl += "&refNo=" + this.filter.refNo;
    if (this.filter.tripNo) this.filterUrl += "&tripNo=" + this.filter.tripNo;
    if (this.filter.grnNo) this.filterUrl += "&grnNo=" + this.filter.grnNo;
    if (this.filter.vendor_id)
      this.filterUrl += "&vendor_id=" + this.filter.vendor_id;
    common.setLoading(true);
    await this.showPage(1);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
  }

  makeFilterUrl() {
    this.filterUrl = "";
    if (this.filter.startDate)
      this.filterUrl += "&startDate=" + this.filter.startDate;
    if (this.filter.endDate)
      this.filterUrl += "&endDate=" + this.filter.endDate;
    if (this.filter.seqNo) this.filterUrl += "&seqNo=" + this.filter.seqNo;
    if (this.filter.refNo) this.filterUrl += "&refNo=" + this.filter.refNo;
    if (this.filter.tripNo) this.filterUrl += "&tripNo=" + this.filter.tripNo;
    if (this.filter.grnNo) this.filterUrl += "&grnNo=" + this.filter.grnNo;
    if (this.filter.vendor_id)
      this.filterUrl += "&vendor_id=" + this.filter.vendor_id;
  }
  async downloadAll() {
    let url = "/api/paymentmade/download/grid?_search=true";
    this.makeFilterUrl();
    url = url + this.filterUrl;
    // console.log(url);
    window.open(url, "_blank");
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.v-card__subtitle,
.v-card__text {
  font-size: 14px;
}

.v-expansion-panel-header--active {
  background-color: aliceblue;
  min-height: 50px !important;
}

tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
</style>
